// extracted by mini-css-extract-plugin
export default {"stickyItemColumn":"CompletedItems_stickyItemColumn__Lpy8T","cell":"CompletedItems_cell__iGhGf"};